module.exports = __webpack_public_path__ + "img/about-icon_3.ab93b9e6.png";